module.exports = __webpack_public_path__ + "img/smzq4.74c8784a.png";